import Alert from "react-bootstrap/esm/Alert";

function SearchResultsWarning({ searchResults }) {
  return (
    <div>
      <Alert className="bkgrnd-rg-green mt-3">
        <p className="text-center my-1">
          We couldn't find your exact tire size, but we found similiar results displayed below
        </p>
      </Alert>
    </div>
  );
}

export default SearchResultsWarning;
